import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_AVATAR_SUCCESS,
  LOGOUT,
} from "../actions/types";

const user = JSON.parse(localStorage.getItem("user"));

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case UPDATE_AVATAR_SUCCESS:
      // Update user avatar in state and localStorage
      const updatedUser = { ...state.user, avatar: payload.avatar };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      return {
        ...state,
        user: updatedUser,
      };
    case UPDATE_USER_SUCCESS:
      // Only update if it's the current logged-in user (same uuid)
      if (state.user && payload.uuid === state.user.uuid) {
        const updatedUserProfile = { ...state.user, ...payload };
        localStorage.setItem("user", JSON.stringify(updatedUserProfile));
        return {
          ...state,
          user: updatedUserProfile,
        };
      }
      // Otherwise, don't update currentUser (admin updating other users' data)
      return state;
    case UPDATE_USER_FAIL:
      return state;
    default:
      return state;
  }
}
